import type { AppSearch } from "@/routes/_main/services/create.lazy.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/services/create")({
    validateSearch: (params): AppSearch => {
        // TODO: validate search params
        return params as AppSearch;
    },
});
